"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.zeropad = zeropad;
function zeropad(value, length) {
    var str = "".concat("0".repeat(length)).concat(value);
    return str.slice(str.length - length);
}
